package pnemonic.balloon_pop.view.theme

import androidx.compose.ui.graphics.Color

val Gold = Color(0xFFFFD700)
val Orange = Color(0xFFF7941D)
val DarkRed = Color(0xFF880000)
val Sky = Color(0xFF00BFFF)

val colorPrimary = Color(0xFFCC4488)
val colorSecondary = Color.Green
val colorButton = Color.White.copy(alpha = 0.8f)
val colorButtonBackground = Color.Black.copy(alpha = 0.25f)
